import { onPopState, REDIRECT } from "shared_non_critical/events/popstate";

// The event is triggered when browser back button is clicked
// redirects back to srp when window.history.state has srp flag and path
export const addPopStateListener = () => {
  onPopState(
    {
      type: REDIRECT,
      condition: ({srp, path}) => srp && path,
      handler: ({path}) => path
    }
  );

  onPopState(
    {
      type: REDIRECT,
      condition: ({isQuickView, path}) => isQuickView && path,
      handler: ({path}) => path
    }
  );
};



// WEBPACK FOOTER //
// ./ldp/common_platform/events/popstate.js